import { Position } from 'reactflow';
import { applyVueInReact } from 'vuereact-combined';

import styles from './NodeTypes.module.scss';
import { HiddenHandle } from './common';
import { NodeProps } from '../types';
import FlowTreeBlockWrapper from '@/components/FlowTree/FlowTreeBlockWrapper.vue';
const VueFlowTreeBlock = applyVueInReact(FlowTreeBlockWrapper);
export default function BranchConsolidateNode({ data, sourcePosition = Position.Top, targetPosition = Position.Bottom }: NodeProps) {
	return (
		<div className={styles.clusterEndWrapper}>
			<HiddenHandle type="source" position={sourcePosition} />
			<div className={styles.clusterEndSpacer} />
			<VueFlowTreeBlock
				block={data.node}
				className={styles.clusterEndContent}
				workflowVersionId={data.workflowVersionId}
				hasLoadedNodesData={data.hasLoadedNodesData}
				canAddContextualActionNode={data.canAddContextualActionNode}
			/>
			<div className={styles.clusterEndSpacer} />
			<HiddenHandle type="target" position={targetPosition} />
		</div>
	);
}
